import gql from 'graphql-tag';

const MY_AUCTION_CLAIM_FRAGMENT = gql`
  fragment MyAuctionClaimFragment on MyAuctionClaim {
    dealer_id
    dealer_name
  }
`;

export default MY_AUCTION_CLAIM_FRAGMENT;
